import React from "react";
import { Box, Typography, Container, Stack, Divider } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // İkonlar için
import ForestIcon from "@mui/icons-material/Forest";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PeopleIcon from "@mui/icons-material/People";

const AboutUs = () => {
  return (
    <Container maxWidth="md" sx={{ mt:{xs:'5vh', md:'15vh'}, mb: 5 }}>
      {/* Başlık */}
      <Typography variant="h3"  textAlign="center"  gutterBottom>
        Meistä
      </Typography>

      {/* Açıklama */}
      <Typography variant="h4" textAlign="center" color="textSecondary" sx={{ mb: 4 }}>
        Ehankki Kaluste – Kestävä ja Edullinen Huonekalukauppa
      </Typography>

      {/* Ana İçerik */}
      <Typography variant="h5" textAlign="center" sx={{ mb: 4 }}>
        Ehankki Kaluste on suomalainen huonekaluliike, joka tarjoaa 
         sekä uuden että käytetyn laadukkaan huonekalun edulliseen hintaan. 
        Meidän tavoitteemme on yhdistää kestävä kehitys, ekologisuus ja budjettiystävällisyys, 
        jotta jokainen asiakas löytää itselleen sopivan ratkaisun kodin sisustukseen.
      </Typography>

      {/* Neden Bizi Seçmelisiniz Bölümü */}
      <Divider sx={{ mb: 4 }} />

      <Stack spacing={3}>
        <Stack direction="row" spacing={2} alignItems="center">
          <CheckCircleIcon color="success" fontSize="large" />
          <Typography variant="h6" >
            Laadukkaat ja kestävät huonekalut
          </Typography>
        </Stack>
        <Typography variant="body1">
          Tarjoamme huolellisesti valikoidut uudet ja käytetyt huonekalut, jotka ovat sekä tyylikkäitä että kestäviä.
        </Typography>

        <Stack direction="row" spacing={2} alignItems="center">
          <ForestIcon color="success" fontSize="large" />
          <Typography variant="h6" >
            Ekologinen valinta
          </Typography>
        </Stack>
        <Typography variant="body1">
          Kierrätettyjen ja kunnostettujen huonekalujen ostaminen auttaa vähentämään jätettä ja säästämään luonnonvaroja.
        </Typography>

        <Stack direction="row" spacing={2} alignItems="center">
          <LocalShippingIcon color='success' fontSize="large" />
          <Typography variant="h6" >
            Nopea toimitus
          </Typography>
        </Stack>
        <Typography variant="body1">
          Toimitamme huonekalut <b>Uudenmaan alueella nopeasti ja joustavasti.</b>
        </Typography>

        <Stack direction="row" spacing={2} alignItems="center">
          <PeopleIcon color='success' fontSize="large" />
          <Typography variant="h6" >
            Asiakastyytyväisyys etusijalla
          </Typography>
        </Stack>
        <Typography variant="body1">
          Tarjoamme henkilökohtaista palvelua ja varmistamme, että jokainen asiakas saa juuri tarvitsemansa tuotteen.
        </Typography>
      </Stack>

      <Divider sx={{ mt: 4, mb: 4 }} />

      {/* Ekstra Açıklama */}
      <Typography variant="body1" textAlign="center" sx={{ mb: 4 }}>
        Meiltä löydät laajan valikoiman <b>sohvia, sänkyjä, ruokapöytiä, säilytyskalusteita ja muita kodin sisustustuotteita.</b> 
        Käytettyjen huonekalujen osalta varmistamme, että jokainen tuote on <b>kunnostettu, puhdistettu ja valmis käyttöön.</b>
      </Typography>

      <Typography variant="body1" textAlign="center">
        Tarjoamme myös <b>kierrätyspalvelun</b> – voit myydä tai lahjoittaa meille hyväkuntoiset huonekalusi, 
        jotta ne saavat uuden elämän toisessa kodissa!
      </Typography>
    </Container>
  );
};

export default AboutUs;
